/**
 * 入力フォーム系で利用するCSS
 */

import { css } from "@emotion/react";

/** 背景画像読み込み */
/** セレクトアイコン */
import selectImgActive from "assets/img/select/ico-arrowDown-active.png";
import selectImgActive2x from "assets/img/select/ico-arrowDown-active@2x.png";
import selectImgActive3x from "assets/img/select/ico-arrowDown-active@3x.png";
import selectImgDisable from "assets/img/select/ico-arrowDown-disable.png";
import selectImgDisable2x from "assets/img/select/ico-arrowDown-disable@2x.png";
import selectImgDisable3x from "assets/img/select/ico-arrowDown-disable@3x.png";

/** 未チェックボックス */
import emptyImg from "assets/img/checkbox/empty.png";
import emptyImg2x from "assets/img/checkbox/empty@2x.png";
import emptyImg3x from "assets/img/checkbox/empty@3x.png";

/** チェック済みボックス */
import checkedImg from "assets/img/checkbox/checked.png";
import checkedImg2x from "assets/img/checkbox/checked@2x.png";
import checkedImg3x from "assets/img/checkbox/checked@3x.png";

/** バリデーションエラー */
import errorTextImg from "assets/img/caution/ico-caution-caption.png";
import errorTextImg2x from "assets/img/caution/ico-caution-caption@2x.png";
import errorTextImg3x from "assets/img/caution/ico-caution-caption@3x.png";

/** バリデーションOK */
import checkerImg from "assets/img/checker/ico-checker.png";
import checkerImg2x from "assets/img/checker/ico-checker@2x.png";
import checkerImg3x from "assets/img/checker/ico-checker@3x.png";

/** バリデーションエラー */
import errorImg from "assets/img/checker/ico_caution.png";
import errorImg2x from "assets/img/checker/ico_caution@2x.png";
import errorImg3x from "assets/img/checker/ico_caution@3x.png";

export const content = css`
  padding: 22px 16px;
  background-color: var(--mtg-blue-4);
  animation: fadeIn 0.2s ease 0.3s 1 normal;
  margin-bottom: var(--mtg-text-margin-group);
`;

export const mtgAccordion = css`
  > div {
    margin: var(--mtg-confirmation-item-margin) 0;
  }
`;

export const mtgGroup = css`
  margin-bottom: var(--mtg-text-margin-group);
`;

export const mtgLabel = css`
  display: block;
  margin-bottom: var(--mtg-text-margin-label);
  font-size: var(--mtg-body-strong-s);
  font-weight: var(--mtg-body-strong-w);
  display: flex;
  justify-content: space-between;
`;

/** タイトルラベル二分割 */
export const labelWithOptionIconHarf = css`
  display: flex;

  label {
    width: 50%;

    :nth-of-type(2) {
      margin-left: 16px;
    }
  }
`;

/** 必須・任意コンポーネント用 */
export const optionContainer = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  height: 24px;
  line-height: 21.98px;
`;

export const optionLabel = css`
  font-size: var(--mtg-body-strong-s);
  font-weight: var(--mtg-body-strong-w);
`;

/** 必須ラベル */
export const optionLabelRequired = css`
  display: none;
`;

/** 任意ラベル */
export const optionLabelAny = css`
  background-color: var(--mtg-blue-2);
  color: var(--mtg-white);
  font-size: 12px;
  font-weight: var(--mtg-caption-w);
  height: 24px;
  padding: 2px 8px 3px;
  border-radius: 60px;
`;

// 注意書き
export const cautionWrap = css`
  display: flex;
  align-items: center;
  margin-bottom: var(--mtg-attention-margin-title);
`;

export const cautionImg = css`
  align-self: flex-start;
  vertical-align: top;
  object-fit: contain;
  width: 40px;
  height: 40px;
  margin-right: 8px;
`;

export const cautionLargeText = css`
  flex: 1;
  margin-bottom: 0;
  font-size: var(--mtg-h1-s);
  font-weight: var(--mtg-h1-w);
  color: var(--mtg-live-red);
`;

export const cautionSmallText = css`
  flex: 1;
  margin-bottom: 0;
  font-weight: var(--mtg-h1-w);
  color: var(--mtg-live-red);
`;

/** キャプション */
export const mtgCaption = css`
  margin-top: var(--mtg-text-margin-read);
  font-size: var(--mtg-caption-s);
  font-weight: var(--mtg-caption-w);
  line-height: 18.84px;
`;

export const mtgAccordionLabel = css`
  ${mtgLabel}
  line-height: 1.45;
`;

export const mtgBody = css`
  margin-bottom: 16px;
  font-size: var(--mtg-body-s);
  font-weight: var(--mtg-body-w);
  line-height: 21.98px;
  word-wrap: break-word;
`;

export const mtgBodyNoMb = css`
  font-size: var(--mtg-body-s);
  font-weight: var(--mtg-body-w);
`;

export const mtgAccordionBody = css`
  ${mtgBody}
  line-height: 1.45;

  /* 改行指定 */
  white-space: pre-wrap;
  word-wrap: break-word;
`;

export const mtgAccordionCaption = css`
  font-size: var(--mtg-caption-s);
  font-weight: var(--mtg-caption-w);
  line-height: 1.57;
`;

export const backButton = css`
  display: block;
  margin: 0 auto var(--mtg-text-margin-button);
  width: 100%;
  height: 56px;
  border-radius: var(--mtg-border-radius);
  font-size: var(--mtg-button-s);
  font-weight: var(--mtg-button-w);
  color: var(--mtg-grey-1);
`;

export const blueButton = css`
  display: block;
  margin: 40px auto 0;
  width: 100%;
  height: 56px;
  border-radius: var(--mtg-border-radius);
  background-color: var(--mtg-urbanblue);

  font-size: var(--mtg-button-s);
  font-weight: var(--mtg-button-w);
  color: var(--mtg-white);

  &:hover {
    background-color: var(--mtg-blue-1);
  }
`;

export const blueButton_inactive = css`
  /* blueButtonのスタイルを代入 */
  ${blueButton}
  background-color: var(--mtg-grey-2);
  pointer-events: none;

  &:hover {
    background-color: var(--mtg-grey-2);
  }
`;

export const whiteButton = css`
  display: block;
  margin: 0 auto var(--mtg-text-margin-button);
  width: 100%;
  height: 56px;
  border-radius: var(--mtg-border-radius);
  background-color: #ffffff;

  font-size: var(--mtg-button-s);
  font-weight: var(--mtg-button-w);
  color: var(--mtg-urbanblue);
  border: 1px solid var(--mtg-urbanblue);

  :hover {
    background-color: var(--mtg-blue-4);
  }
`;

export const whiteButton_inactive = css`
  /* whiteButtonのスタイルを代入 */
  ${whiteButton}
  background-color: var(--mtg-grey-2);
  pointer-events: none;

  &:hover {
    background-color: var(--mtg-grey-2);
  }
`;

/**
 * 二分割された領域を囲うスタイル（使用例）
 * <div css={halfWrap}> <input ...
 */
export const halfWrap = css`
  display: flex;
`;

/**
 * 二分割された文字入力領域（右側の空領域）
 * <div css={harfEmpty} />
 */
export const harfEmpty = css`
  flex: 1;
  padding-left: 16px;
  opacity: 0;
`;

/**
 * アイコン表示のためにinputを囲うスタイル（使用例）
 * <div css={inputWrap}> <input ...
 */
export const inputWrap = css`
  position: relative;
  flex: 1;

  :nth-of-type(2) {
    margin-left: 16px;
  }

  :only-of-type {
    margin-left: 0;
  }
`;

/**
 * インプットを囲うエリアのスタイル（使用例）
 * <label css={inputArea_check} htmlFor="noServicesToStopLabel">
 */
export const inputArea = css`
  display: flex;
  align-items: center;
  min-height: 56px;
  padding: 16px 48px 16px 64px;

  border: 1px solid var(--mtg-grey-3);
  background-color: var(--mtg-white);
  border-radius: var(--mtg-border-radius);

  font-size: var(--mtg-body-s);
  font-weight: var(--mtg-body-w);

  transition: all 0.2s;
  transition: font-size 0s;

  :nth-of-type(2) {
    margin-left: 16px;
  }
`;

/**
 * 文字入力領域のスタイル（使用例）
 * <input css={errors.mail ? inputArea_text_error : inputArea_text} ...
 */
export const inputArea_text = css`
  ${inputArea}
  padding-left: 16px;

  width: 100%;
  flex: 1;

  :focus,
  :hover {
    border-color: var(--mtg-urbanblue);
  }

  ::placeholder {
    color: var(--mtg-grey-2);
  }
`;

/** バリデーションエラー時 */
export const inputArea_text_error = css`
  ${inputArea_text}
  border-color: var(--mtg-live-red);

  :focus,
  :hover {
    border-color: var(--mtg-live-red);
    box-shadow: inset 0 0 0 1px var(--mtg-live-red);
  }

  :focus-within {
    background-color: var(--mtg-red-4);
  }
`;

/** ラジオ、チェックボックス */
export const inputArea_check = css`
  ${inputArea}
  margin-bottom: var(--mtg-input-item-margin);

  :focus-within,
  :hover {
    border-color: var(--mtg-urbanblue);
  }

  :nth-of-type(2) {
    margin-left: 0;
  }
`;

export const inputArea_check_error = css`
  ${inputArea_check}
  border-color: var(--mtg-live-red);

  :focus,
  :hover {
    border-color: var(--mtg-live-red);
    box-shadow: inset 0 0 0 1px var(--mtg-live-red);
  }

  :focus-within {
    background-color: var(--mtg-red-4);
  }
`;

/** チェックボックス（アコーディオン用サブチェックボックス）*/
export const inputArea_subCheck = css`
  display: flex;
  align-items: center;
  min-height: 56px;
  padding: 16px 16px 16px 86px;
  border-bottom: 1px solid var(--mtg-grey-3);

  background-color: var(--mtg-blue-4);

  font-size: var(--mtg-body-s);
  font-weight: var(--mtg-body-w);

  transition: all 0.2s;
  transition: font-size 0s;

  :nth-of-type(2) {
    margin-left: 16px;
  }
  margin-bottom: 0;

  :nth-of-type(2) {
    margin-left: 0;
  }
`;

/** 非活性 */
export const inputArea_disabled = css`
  background-color: var(--mtg-grey-3);
  color: var(--mtg-grey-1);

  cursor: default;

  :focus,
  :hover {
    border-color: var(--mtg-grey-3);
  }
`;

/** テキストエリア 入力欄 */
export const inputTextarea = css`
  display: flex;
  align-items: center;
  height: 160px;
  padding: 12px;

  border: 1px solid var(--mtg-grey-3);
  background-color: var(--mtg-white);
  border-radius: var(--mtg-border-radius);

  font-size: var(--mtg-body-s);
  font-weight: var(--mtg-body-w);

  transition: all 0.2s;
  transition: font-size 0s;

  :nth-of-type(2) {
    margin-left: 16px;
  }

  resize: none;
`;

// テキストエリア 入力欄　入力
export const inputArea_textarea = css`
  ${inputTextarea}
  padding-left: 16px;

  width: 100%;
  flex: 1;

  :focus,
  :hover {
    border-color: var(--mtg-urbanblue);
  }

  :focus-visible {
    outline: 0px;
  }

  ::placeholder {
    color: var(--mtg-grey-2);
  }
`;

/** テキストエリア 入力欄　バリデーションエラー */
export const inputArea_textarea_error = css`
  ${inputArea_textarea}
  border-color: var(--mtg-live-red);

  :focus,
  :hover {
    border-color: var(--mtg-live-red);
    box-shadow: inset 0 0 0 1px var(--mtg-live-red);
  }

  :focus-within {
    background-color: var(--mtg-red-4);
  }
`;

/**
 * ラジオボタン（使用例）
 * <input css={radioInput} type="radio" ...
 * @see https://itokoba.com/archives/768
 */
export const radioInput = css`
  position: absolute;

  /* 円 */
  :before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: -40px;
    transform: translateY(-50%);

    width: 24px;
    height: 24px;
    border-radius: 50%;

    background-color: var(--mtg-grey-3);
    border: 3px solid var(--mtg-white);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    box-sizing: border-box;

    transition: background-color 0.2s;
  }
  :checked:before {
    background-color: var(--mtg-urbanblue);
  }
`;

/**
 * チェックボックス（使用例）
 * <input css={checkInput} type="checkbox" ...
 * @see https://dev.to/ingosteinke/responsive-background-images-with-image-set-the-srcset-for-background-image-259a
 */
export const checkInput = css`
  position: absolute;

  /* アイコン */
  :before,
  :after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: -28px;
    transform: translateY(-50%);

    width: 20px;
    height: 20px;

    transition: opacity 0.2s;
  }

  :before {
    opacity: 1;

    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(${emptyImg});

    background-image: -webkit-image-set(
      url(${emptyImg}) 1x,
      url(${emptyImg2x}) 2x,
      url(${emptyImg3x}) 3x
    );

    background-image: image-set(
      url(${emptyImg}) 1x,
      url(${emptyImg2x}) 2x,
      url(${emptyImg3x}) 3x
    );
  }
  :checked:before {
    opacity: 0;
  }

  :after {
    opacity: 0;

    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(${checkedImg});

    background-image: -webkit-image-set(
      url(${checkedImg}) 1x,
      url(${checkedImg2x}) 2x,
      url(${checkedImg3x}) 3x
    );

    background-image: image-set(
      url(${checkedImg}) 1x,
      url(${checkedImg2x}) 2x,
      url(${checkedImg3x}) 3x
    );
  }
  :checked:after {
    opacity: 1;
  }
`;

/**
 * バリデーションエラーテキスト（使用例）
 * <p css={validationErrorText}>
 */
export const validationErrorText = css`
  display: flex;
  align-items: center;

  margin-top: var(--mtg-text-margin-validation-error);
  font-size: var(--mtg-caption-s);
  font-weight: var(--mtg-caption-w);
  color: var(--mtg-live-red);
  line-height: 19px;

  :before {
    content: "";
    display: block;
    align-self: flex-start;

    width: 16px;
    min-width: 16px;
    height: 19px;
    margin-right: 4px;

    background: center;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(${errorTextImg});

    background-image: -webkit-image-set(
      url(${errorTextImg}) 1x,
      url(${errorTextImg2x}) 2x,
      url(${errorTextImg3x}) 3x
    );

    background-image: image-set(
      url(${errorTextImg}) 1x,
      url(${errorTextImg2x}) 2x,
      url(${errorTextImg3x}) 3x
    );
  }
`;
/**
 * バリデーションOKアイコン（utilities/validation.jsで利用）
 * <span css={handlingValidationIcon(getValues("postCode"), errors.postCode)} />
 */
export const validationIcon = css`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);

  width: 24px;
  height: 24px;

  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${checkerImg});

  background-image: -webkit-image-set(
    url(${checkerImg}) 1x,
    url(${checkerImg2x}) 2x,
    url(${checkerImg3x}) 3x
  );

  background-image: image-set(
    url(${checkerImg}) 1x,
    url(${checkerImg2x}) 2x,
    url(${checkerImg3x}) 3x
  );
`;

/** バリデーションエラーアイコン（utilities/validation.jsで利用） */
export const validationIcon_error = css`
  ${validationIcon}
  background-image: url(${errorImg});

  background-image: -webkit-image-set(
    url(${errorImg}) 1x,
    url(${errorImg2x}) 2x,
    url(${errorImg3x}) 3x
  );

  background-image: image-set(
    url(${errorImg}) 1x,
    url(${errorImg2x}) 2x,
    url(${errorImg3x}) 3x
  );
`;

/**
 * ExternalLink
 */
export const externakLinkWrap = css`
  display: inline;
  font-size: 0;
  margin-bottom: var(--mtg-link-margin);
`;

export const externakLinkText = css`
  display: inline;
  font-size: var(--mtg-body-s);
  font-weight: var(--mtg-body-w);
  color: var(--mtg-urbanblue);
  text-decoration: underline;
`;

export const externakLinkImg = css`
  vertical-align: bottom;
  object-fit: contain;
  width: 20px;
  height: 20px;
`;

/** アコーディオン（accordion/Accordion.jsxで利用）*/
export const accordionWrap = css`
  overflow: hidden;
  margin: var(--mtg-item-margin-narrow) 0;
  border: 1px solid var(--mtg-grey-3);
  background-color: var(--mtg-white);
  border-radius: var(--mtg-border-radius);
`;

export const accordionTitleWrap = css`
  display: flex;
  align-items: center;
  height: 54px;
  cursor: pointer;
`;

export const accordionTitle = css`
  flex: 1;
  margin: 0 26px;
  font-size: var(--mtg-body-s);
  font-weight: var(--mtg-body-w);
  line-height: 21.98px;
`;

export const accordionImg = css`
  vertical-align: top;
  object-fit: contain;
  width: 40px;
  height: 40px;
  margin-right: 8px;
`;

export const accordionContent = css`
  padding: 22px 16px;
  background-color: var(--mtg-blue-4);
`;

export const content_open = css`
  display: block;
`;

export const content_close = css`
  display: none;
`;

/**
 * セレクトアイコン（<div css={inputWrap}>内末尾で利用）
 * <span css={selectIcon} />
 */
export const selectIcon = css`
  position: absolute;
  top: 50%;
  right: 4px;
  transform: translateY(-50%);

  width: 41px;
  height: 40px;
  pointer-events: none;

  background-size: contain;
  background-repeat: no-repeat;
`;

/**
 * セレクトアイコン（<div css={inputWrap}>内末尾で利用）
 * <span css={selectIcon} />
 */
export const selectIconActive = css`
  ${selectIcon}
  background-image: url(${selectImgActive});

  background-image: -webkit-image-set(
    url(${selectImgActive}) 1x,
    url(${selectImgActive2x}) 2x,
    url(${selectImgActive3x}) 3x
  );

  background-image: image-set(
    url(${selectImgActive}) 1x,
    url(${selectImgActive2x}) 2x,
    url(${selectImgActive3x}) 3x
  );
`;

/**
 * セレクトアイコン（<div css={inputWrap}>内末尾で利用）
 * <span css={selectIcon} />
 */
export const selectIconDisable = css`
  ${selectIcon}
  background-image: url(${selectImgDisable});

  background-image: -webkit-image-set(
    url(${selectImgDisable}) 1x,
    url(${selectImgDisable2x}) 2x,
    url(${selectImgDisable3x}) 3x
  );

  background-image: image-set(
    url(${selectImgDisable}) 1x,
    url(${selectImgDisable2x}) 2x,
    url(${selectImgDisable3x}) 3x
  );
`;

/** ArrowLink/BackToInputLink */
export const linkMarginBottom = css`
  margin-bottom: var(--mtg-link-margin);
`;

export const linkWrap = css`
  font-size: 0;
`;

export const linkText = css`
  display: inline-block;
  font-size: var(--mtg-body-s);
  font-weight: var(--mtg-body-w);
  color: var(--mtg-urbanblue);
  :hover {
    text-decoration: underline;
    color: var(--mtg-blue-1);
  }
`;

export const linkFlexWrap = css`
  display: flex;
  align-items: center;
`;

export const linkImg = css`
  vertical-align: top;
  object-fit: contain;
  width: 8px;
  height: 13px;
  margin-top: 2px;
  margin-left: 5px;
`;

export const backToInputLinkIcon = css`
  &:before {
    content: "";
    display: inline-block;
    margin-right: 9px;
    vertical-align: middle;
    line-height: 1;
    width: 8.24px;
    height: 8.24px;
    border: 1px solid #004098;
    border-radius: 1px;
    border-left: 0;
    border-bottom: 0;
    box-sizing: border-box;
    -webkit-transform: translateX(25%) rotate(-135deg);
    -moz-transform: translateX(25%) rotate(-135deg);
    -ms-transform: translateX(25%) rotate(-135deg);
    transform: translateX(25%) rotate(-135deg);
  }
`;

/** リスト */
export const mtgList = css`
  list-style-type: none;
`;

export const mtgListContents = css`
  position: relative;
  margin: 0 20px var(--mtg-list-margin);
  margin-right: 0;
  font-size: var(--mtg-body-list-s);
  font-weight: var(--mtg-body-list-w);
  line-height: 18.84px;
  a {
    text-decoration: underline;
    :hover {
      text-decoration: none;
    }
  }

  &:last-child {
    margin-bottom: 12px;
  }

  &:before {
    content: "";
    position: absolute;
    top: 10px;
    left: -14px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: var(--mtg-midnight);
  }
`;

/** キャプションリスト */
export const mtgCaptionList = css`
  ${mtgList}
  margin-top: 8px;

  li {
    ${mtgListContents}
  }
`;

/** ヒントモーダルモーダル（タイトル） */
export const LabelWithOptionIconImg = css`
  vertical-align: sub;
  object-fit: contain;
  margin-left: 5px;
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

/** ヒントモーダルモーダル（ヒントラベル） */
export const labelWithHintWrap = css`
  display: flex;
  align-items: center;
  margin-bottom: var(--mtg-text-margin-hint);
`;

export const labelWithHintImg = css`
  vertical-align: top;
  object-fit: contain;
  margin-left: 5px;
  width: 14px;
  height: 14px;
  cursor: pointer;
`;

export const labelWithHintText = css`
  font-size: var(--mtg-caption-s);
  font-weight: var(--mtg-caption-w);
  cursor: pointer;
  color: var(--mtg-urbanblue);

  :hover {
    text-decoration: underline;
  }
`;

export const modalWrap = css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--mtg-midnight-modal);
  transition: opacity 0.2s;

  /* ヘッダーよりも上へ表示 */
  z-index: 20;
`;

export const modalWrap_hidden = css`
  ${modalWrap}
  opacity: 0;
  pointer-events: none;
`;

export const modalContents = css`
  position: relative;
  padding: var(--mtg-modal-padding-height) var(--mtg-modal-padding-width);
  width: 84%;
  max-width: 500px;
  max-height: 80%;
  background-color: var(--mtg-white);
  border-radius: var(--mtg-border-radius);

  overflow-y: scroll;
`;

export const closeImg = css`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;

  vertical-align: top;
  object-fit: contain;
  width: 40px;
  height: 40px;
`;

/** ヒントモーダル */
export const modalGroup = css`
  :not(:last-of-type) {
    margin-bottom: 24px;
  }
`;

export const modalLabel = css`
  margin-bottom: var(--mtg-text-margin-hint);
  font-size: var(--mtg-body-strong-s);
  font-weight: var(--mtg-body-strong-w);
`;

export const modalImg = css`
  object-fit: contain;
  display: block;
  margin: 0 auto;
  margin-top: 8px;
  width: 100%;
  max-width: 300px;
  height: auto;
`;

/** 確認カード */
export const mtgWhiteBackground = css`
  background-color: var(--mtg-white);
  padding: 20px 16px;
  border-radius: 8px;
  margin-bottom: var(--mtg-item-margin);
`;

export const mtgSection = css`
  border: none;
  border-bottom: 1px solid var(--mtg-grey-3);
  margin: var(--mtg-confirmation-item-margin) 0;
`;

export const waitingLabel = css`
  text-align: center;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  :after {
    content: "";
    animation: loading 2s infinite;
  }
  @keyframes loading {
    0% {
      content: "";
    }
    20% {
      content: "";
    }
    40% {
      content: ".";
    }
    60% {
      content: "..";
    }
    80% {
      content: "...";
    }
    100% {
      content: "...";
    }
  }
`;
